import { kPseudoCreatorIdForPreview } from '@ps/models/constants';

/**
 * True when a creator/seller id is the reserved preview placeholder
 * ({@link kPseudoCreatorIdForPreview}) — i.e. we're rendering the AI-profile-
 * builder preview against a synthetic seller with no real backend record.
 *
 * Surfaces call this to render inert in preview (no PDP / collection navigation,
 * no availability fetch), since the reserved id 500s any backend call. The
 * single predicate for the check — use it instead of comparing to the constant
 * inline (the comparison was duplicated across many bio surfaces).
 */
export function isPreviewCreatorId(id: string | undefined | null): boolean {
  return id === kPseudoCreatorIdForPreview;
}
